// Whitelist do que é enviado à API ao salvar um formulário. Vive fora do
// componente de propósito: campo novo esquecido aqui é descartado em silêncio
// ao salvar, e isso já custou um bug de "não salva" no passado. Função pura =
// dá para testar a whitelist sem montar store, router e i18n.
export const buildPayload = (form, { fieldMapping } = {}) => ({
  name: form.name,
  slug: (form.slug || '').replace(/^-+|-+$/g, ''),
  fields: form.fields,
  theme: form.theme,
  funnel_id: form.funnel_id || null,
  stage_name: form.funnel_id ? form.stage_name || null : null,
  inbox_id: form.inbox_id || null,
  consent_enabled: form.consent_enabled,
  consent_text: form.consent_text,
  success_mode: form.success_mode,
  success_message: form.success_message,
  redirect_url: form.redirect_url,
  enabled: form.enabled,
  ai_nurture: form.ai_nurture,
  variants: form.variants,
  field_mapping: fieldMapping || {},
  tracking_config: form.tracking_config,
  meta_capi: form.meta_capi,
  notify: form.notify,
  outbound_webhook_url: form.outbound_webhook_url || null,
  outbound_webhook_secret: form.outbound_webhook_secret || null,
  custom_domain: form.custom_domain || null,
  scoring: form.scoring || {},
});
